import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('professionnels', 'comparateur-energie')!;

export default function ProfessionnelsComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/professionnels"
        backLabel="Espace professionnels"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="professionnels" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace professionnels', url: 'https://solutionecofrance.fr/professionnels' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/professionnels/comparateur-energie' },
        ]}
      />
    </>
  );
}
